import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/shop',
            name: 'shop',
            component: () => import("./views/shop.vue"),
            meta: {
                hasBar: true
            }
        },
        {
            path: '/shop/:categoryIdentifier',
            name: 'shopCategory',
            component: () => import("./views/shopCategory.vue"),
        },
        {
            path: '/shop/buy/:offerIdentifier',
            name: 'buyOffer',
            component: () => import("./views/buyOffer.vue"),
        },
        // {
        //     path: '/shop/buy/:offerIdentifier/:isTemp',
        //     name: 'buyOfferTemp',
        //     component: () => import("./views/buyOffer.vue"),
        // },
    ];
};